import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconLessThanOrEqual(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7399 6.32733C11.1114 6.73599 11.0813 7.36844 10.6727 7.73995L5.98661 12L10.6727 16.2601C11.0813 16.6316 11.1114 17.264 10.7399 17.6727C10.3684 18.0813 9.73599 18.1115 9.32733 17.7399L3.82733 12.7399C3.61885 12.5504 3.5 12.2818 3.5 12C3.5 11.7183 3.61885 11.4496 3.82733 11.2601L9.32733 6.26007C9.73599 5.88856 10.3684 5.91868 10.7399 6.32733Z"
        fill="currentColor"
      />
      <path
        d="M14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11H19C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9H14Z"
        fill="currentColor"
      />
      <path
        d="M14 13C13.4477 13 13 13.4477 13 14C13 14.5523 13.4477 15 14 15H19C19.5523 15 20 14.5523 20 14C20 13.4477 19.5523 13 19 13H14Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
